import ARROW_KEYS_GIF from "@assets/quick-news/arrowkeys.gif";
import CLOSE from "@assets/quick-news/close.svg";
import TOOLTIP from "@assets/quick-news/qn_tooltip.svg";
import { QN_ANALYTICS_EVENT_BASE } from "@config/QuickNewsConstants";
import { useTMCustomEventAnalyticsCall } from "@hooks/useAnalyticsCall/useTMCustomEventAnalyticsCall";
import { type ReactElement, useState } from "react";
import { twMerge } from "tailwind-merge";

export function QnHelpBtn(): ReactElement {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const sendAnalyticsEvent = useTMCustomEventAnalyticsCall();

  const handleClick = (): void => {
    setIsTooltipOpen((prev) => !prev);

    sendAnalyticsEvent({
      ...QN_ANALYTICS_EVENT_BASE,
      eventAction: "click help",
    });
  };

  const buttonClasses = twMerge(
    "inline-flex h-[40px] w-[40px] items-center justify-center rounded-full transition-colors",
    isTooltipOpen && "bg-white-100/90",
  );
  const imgClasses = isTooltipOpen ? "p-2" : "p-1";
  const tooltipClasses = twMerge(
    "pointer-events-none absolute bottom-10 right-0 z-20 h-[183px] w-[183px] translate-y-full rounded-full bg-grey-700 p-3 text-center text-xs text-white-100 opacity-0 transition-opacity duration-300",
    isTooltipOpen && "opacity-100",
  );

  return (
    <div className="absolute right-4 hidden md:right-8 lg:block">
      <div className="relative z-30 m-auto">
        <button
          type="button"
          aria-label="Help"
          onClick={handleClick}
          className={buttonClasses}
        >
          <img
            alt="info"
            src={isTooltipOpen ? CLOSE : TOOLTIP}
            width={40}
            height={24}
            className={imgClasses}
          />
        </button>
      </div>

      {/* Tooltip */}
      <div className={tooltipClasses}>
        <img
          alt="info"
          src={ARROW_KEYS_GIF}
          width={120}
          height={100}
          className="mx-auto pt-3"
        />
        விரைவுச்செய்திகளுக்கு Arrow விசைகளைப் பயன்படுத்தவும்
      </div>
    </div>
  );
}
